import { Component } from '@angular/core';
import { AriaLabels } from '@maced/angular-components/lib/error-state/error-state-interface';

@Component({
  selector: 'app-error-state',
  templateUrl: './error-state.component.html',
  styleUrls: ['./error-state.component.scss']
})
export class ErrorStateComponent {

  imageUrl = '/assets/default/images/error_blue/Bookshelf-is-empty.svg';
  id = 'errorContainer1';
  errorMessage = '';
  title = 'Bookshelf is error';
  subTitle = 'To add new course please visit Macmillan Education Everywhere';
  showLink = true;
  showButton = false;
  buttonId = 'ErrorStateButton';
  linkUrl = 'https://www.macmillaneducationeverywhere.com/';
  linkLabel = 'Macmillan Education Everywhere';
  linkTarget = '_blank';
  ariaLabels: AriaLabels = {
    imageAltText: 'banner-image'
  }
  
  imageUrl2 = '/assets/default/images/error_blue/My-downloads-empty.svg';
  id2 = 'errorContainer2';
  errorMessage2 = '';
  title2 = 'My Downloads Error';
  subTitle2 = 'You dont have any units downloaded';
  showLink2 = false;
  buttonLabel = 'Add Content';
  buttonTarget = '';
  buttonType = 'link';
  buttonUrl = '/courses';
  buttonStyleClass = 'u-button--custom-error-state';

  title3 = 'No results have been found';
  id3 = 'errorContainer3';
  imageUrl3 = '/assets/default/images/error_blue/No-search-results.svg';
 
  imageUrl4 = '/assets/default/images/error_blue/502_Bad-gateway.svg';
  title4 = 'Bad Gateway';
  id4 = 'errorContainer4';
  errorMessage4 = 'Error 502';
  buttonLabel4 = 'Optional 1';
  buttonTarget4 = '';
  buttonType4 = 'link';
  buttonUrl4 = '/courses';
  buttonStyleClass4 = 'u-button--custom-error-state';
  buttonId4 = 'ErrorStateButton4';
  linkLabel4 = 'Optional 2'
  
  imageUrl5 = '/assets/default/images/error_blue/404_Page-not-found.svg';
  title5 = 'Page Not Found';
  id5 = 'errorContainer5';
  errorMessage5 = 'Error 404';
  buttonLabel5 = 'Optional 1';
  buttonTarget5 = '';
  buttonType5 = 'link';
  buttonUrl5 = '/courses';
  buttonStyleClass5 = 'u-button--custom-error-state';
  buttonId5 = 'ErrorStateButton5';
  linkLabel5 = 'Optional 2';

  title6 = 'Simple error State';
  id6 = 'errorContainer6';
  errorMessage6 = 'Simple Text';

  title7 = 'Página no encontrada';
  id7 = 'errorContainer7';
  errorMessage7 = 'Error 404';
  buttonLabel7 = 'Botón opcional';
  buttonTarget7 = '';
  buttonType7 = 'link';
  buttonUrl7 = '/courses';
  buttonStyleClass7 = 'u-button--custom-error-state';
  buttonId7 = 'ErrorStateButton7';
  linkLabel7 = 'Enlace opcional';

  title8 = 'पृष्ठ नहीं मिला';
  id8 = 'errorContainer8';
  errorMessage8 = 'त्रुटि ४०४';
  buttonLabel8 = 'वैकल्पिक बटन';
  buttonTarget8 = '';
  buttonType8 = 'link';
  buttonUrl8 = '/courses';
  buttonStyleClass8 = 'u-button--custom-error-state';
  buttonId8 = 'ErrorStateButton8';
  linkLabel8 = 'वैकल्पिक लिंक';

}
